const SCRAPED_ITEM_PLACEHOLDER_TITLES = {
  EMPTY_MENU_TITLE: 'Empty menu title',
  CORRUPT_MENU_TITLE: 'Corrupt menu title',
  EMPTY_DISH_NAME: 'Empty dish name',
  CORRUPT_DISH: 'Corrupt dish',
}

export default SCRAPED_ITEM_PLACEHOLDER_TITLES
